import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import cx from 'classnames';

// Components.
import HeaderMenuLinks from 'components/HeaderMenuLinks';
import HeaderMenuMain from 'components/HeaderMenuMain';
import HeaderMenuAdditional from 'components/HeaderMenuAdditional';

// Styles.
import styles from './styles.module.scss';

export default class HeaderMenu extends PureComponent {

  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    locationPath: PropTypes.string.isRequired,
  };

  render() {
    const { locationPath, userState, isAuthenticated, isDemoScrolling, theme } = this.props;
    return (
      <Grid container justify="flex-end">
        <div className={styles.headerMenuColLinks}>
          <HeaderMenuLinks
            isAuthenticated={isAuthenticated}
            isDemoScrolling={isDemoScrolling}
            theme={theme}
          />
        </div>
        <div>
          <HeaderMenuMain
            locationPath={locationPath}
            isAuthenticated={isAuthenticated}
            isDemoScrolling={isDemoScrolling}
            userState={userState}
            theme={theme}
          />
        </div>
        <div className={cx(styles.headerMenuAdditionalWrapper, { [styles.isAuth]: isAuthenticated })}>
          <HeaderMenuAdditional
            locationPath={locationPath}
            isAuthenticated={isAuthenticated}
            userState={userState}
            isDemoScrolling={isDemoScrolling}
            theme={theme}
            payConnectedPackages={this.props.payConnectedPackages}
            onClickAdditionalMenuItem={this.onClickAdditionalMenuItem}
            onClickCloseAdditionalMenu={this.onClickCloseAdditionalMenu}
          />
        </div>
      </Grid>
    );
  }

};